import { cx } from 'lib/cx'
import React, { CSSProperties } from 'react'

export default function Tag(props: {
  active?: boolean
  disabled?: boolean
  className?: string
  style?: CSSProperties
  children: React.ReactNode
}) {
  return (
    <span className={props.active ? 'text-background' : 'text-black'}>
      <span
        className={cx(
          'px-16 py-12 rounded-full whitespace-nowrap inline-block',
          props.active ? 'border bg-black' : 'border border-dashed',
          !props.active && !props.disabled && 'hover:border-solid',
          props.className,
        )}
        style={props.style}
      >
        {props.children}
      </span>
    </span>
  )
}
